export default __webpack_public_path__ + "static/media/user.0f7cdf6a.svg";